<template>
  <div
    v-if="hasErrors"
    class="alert-view">
    <strong>{{ title }}</strong>
    <ul
      v-for="(messages, key) in visibleErrors"
      :key="key">
      <li
        v-for="(message, index) in messages"
        :key="index">
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="key === 'bank_account_name' || key === 'bank_account_code'"
          v-html="message">
        </div>
        <!-- eslint-enable vue/no-v-html -->
        <div
          v-for="(str,m) of message.split('\n')"
          v-else
          :key="m">
          {{ str }}
        </div>
        <router-link
          v-if="key==='bank_account_name' && index===0"
          class="c-text-link"
          target="_blank"
          :to="banknameFaqUrl">
          銀行口座名義で使用できる文字はこちら
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AlertView',
  props: {
    banknameFaqUrl: {
      type: String,
      default() {
        return ''
      },
    },
    title: {
      type: String,
      default() {
        return '下記項目に誤りがあります。\nご確認の上、正しく入力し直してください。'
      },
    },
    errors: {
      type: [Object, Array],
      required: true,
    },
  },
  computed: {
    hasErrors() {
      return Object.keys(this.visibleErrors).length > 0
    },
    visibleErrors() {
      const errors = { ...this.errors }
      delete errors.confirmed
      return errors
    },
  },
}
</script>
